import { z } from "zod";

/**
 * The carriers going along with a suborder, as a whole list rather than as one line at a time.
 *
 * Replace semantics, because that is what the picker is doing: they read the yard, decide what
 * goes on the truck, and the answer is the list — not a sequence of edits to a previous answer.
 * An empty array is a valid answer and means nothing goes along.
 */
export const patchSuborderLoadCarriersJsonSchema = z.object({
	loadCarriers: z.array(
		z.object({
			loadCarrierId: z.uuid(),
			quantity: z.coerce.number().int().positive(),
		}),
	),
});

export type PatchSuborderLoadCarriersJsonSchema = z.infer<
	typeof patchSuborderLoadCarriersJsonSchema
>;
